import { AwsRumConfig, AwsRum as AwsRumType } from 'aws-rum-web';
import { useEffect } from 'react';

interface AWSRumProps {
  rumGuestRoleArn: string;
  applicationIds: Record<string, string>;
  identityPoolId: string;
}
const VERSION = '1.0.0';
const REGION = 'us-east-1';
const ENDPOINT = 'https://dataplane.rum.us-east-1.amazonaws.com';
let initialized = false;

export let awsRumClient: AwsRumType | null = null;

const intilializeAWSRum = (config: AwsRumConfig, applicationId: string) => {
  if (initialized) return;
  initialized = true;
  // Since the library is only used client side and is big (>100kb) we download it asynchronously
  import('aws-rum-web').then(({ AwsRum }) => {
    const awsRum = new AwsRum(applicationId, VERSION, REGION, config);
    awsRumClient = awsRum;
    window.onerror = (message) => {
      awsRum.recordError(message);
    };
  });
};

export const useAWSRum = ({ rumGuestRoleArn, applicationIds, identityPoolId }: AWSRumProps) => {
  useEffect(() => {
    if (!rumGuestRoleArn || !applicationIds || !identityPoolId) {
      return;
    }

    const tld = window.location.hostname.split('.').pop();
    const applicationId = tld ? applicationIds[`.${tld}`] : undefined;

    if (!applicationId) {
      return;
    }

    try {
      intilializeAWSRum(
        {
          sessionSampleRate: 0.05,
          guestRoleArn: rumGuestRoleArn,
          identityPoolId,
          endpoint: ENDPOINT,
          telemetries: ['performance', 'errors', 'http'],
          allowCookies: false,
          enableXRay: false,
        },
        applicationId,
      );
    } catch (error: unknown) {
      console.error('Error initializing AWS RUM', error);
    }
  }, [applicationIds, identityPoolId, rumGuestRoleArn]);
};
